// Helper to detect locale date format pattern
export function getLocaleDateFormat(locale: string | undefined): {
  pattern: string;
  separator: string;
} {
  const testDate = new Date(2023, 0, 15); // Jan 15, 2023 - easy to identify parts
  const formatted = testDate.toLocaleDateString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  // Find separator (non-digit character)
  const separator = formatted.match(/[^0-9]/)?.[0] ?? '/';

  // Parse to determine order (we know: year=2023, month=01, day=15)
  const parts = formatted.split(separator);
  let pattern = '';
  for (const part of parts) {
    if (part === '2023') pattern += 'Y';
    else if (part === '01') pattern += 'M';
    else if (part === '15') pattern += 'D';
  }

  return {pattern, separator};
}

export function parseDateString(
  str: string,
  locale: string | undefined,
  utc: boolean | undefined
): Date | undefined {
  if (!str) return undefined;

  const {pattern, separator} = getLocaleDateFormat(locale);
  const parts = str.split(separator);

  if (parts.length !== 3) return undefined;

  let year = 0;
  let month = 0;
  let day = 0;

  for (let i = 0; i < 3; i++) {
    const part = parts[i];
    const patternChar = pattern[i];
    const num = Number.parseInt(part ?? '', 10);

    if (Number.isNaN(num)) return undefined;

    if (patternChar === 'Y') year = num;
    else if (patternChar === 'M') month = num;
    else if (patternChar === 'D') day = num;
  }

  if (utc) {
    return new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
  }
  return new Date(year, month - 1, day, 0, 0, 0, 0);
}
